import React from 'react';

import { CheckCircle, Clear, ClearCircle, Info, Warning } from '../../../icons';

import {
  AlertBar,
  AlertContainer,
  AlertContainerContent,
  AlertContent,
  AlertIconContainer,
  AlertMessage,
  AlertTitle,
} from './Alert.styles';

import { AlertProps } from './Alert.types';

const icons = {
  success: <CheckCircle />,
  warning: <Warning />,
  info: <Info />,
  error: <ClearCircle />,
};

export function Alert({ id, type, title, description, style, onClose, onUndo }: AlertProps) {
  function handleClose() {
    onClose(false);
  }

  function handleUndo() {
    onUndo();
  }

  return (
    <AlertContainer id={id} type={type} style={style} data-testid="alert-testid">
      <AlertBar type={type} />
      <AlertContainerContent>
        <AlertIconContainer>{icons[type]}</AlertIconContainer>
        <AlertContent type={type}>
          {description ? <AlertTitle>{title}</AlertTitle> : <AlertMessage>{title}</AlertMessage>}

          {description && <AlertMessage>{description}</AlertMessage>}
        </AlertContent>
        {onUndo && <button onClick={handleUndo}>Desfazer</button>}
        {onUndo && onClose && <div className="barra-vertical" />}
        {onClose && (
          <AlertIconContainer>
            <button onClick={handleClose}>
              <Clear />
            </button>
          </AlertIconContainer>
        )}
      </AlertContainerContent>
    </AlertContainer>
  );
}
